import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LoginPage from "../operations/pages/LoginPage/LoginPage";
import { rememberDestination } from "./postLoginRedirect";

/**
 * Send an unauthenticated visitor to the login page, but remember where they
 * were going first. This is the only place that knows the intended URL — once
 * we redirect to "/", it's gone.
 */
const RedirectToLogin = () => {
  const location = useLocation();
  rememberDestination(location.pathname, location.search);
  return <Navigate to="/" replace />;
};

export const PublicRoutes = () => {

  const authToken = localStorage.getItem("authToken");

  const isTokenExpired = () => {
    if (!authToken) return true;

    try {
      const payload = JSON.parse(atob(authToken.split(".")[1]));
      return Date.now() > payload.exp * 1000;
    } catch {
      return true;
    }
  };

  const tokenExpired = isTokenExpired();

  if (tokenExpired) {
    localStorage.removeItem("authToken");
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          authToken && !tokenExpired ? (
            <Navigate to="/landing" replace />
          ) : (
            <LoginPage />
          )
        }
      />

      <Route path="*" element={<RedirectToLogin />} />
    </Routes>
  );
};